/* Library */
import React, { Component } from 'react';
import _ from 'lodash';

//import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
 import SelectionTabWithLabel from'../../../../../components/ZUILib/SelectionTabWithLabel';
import TextInput from '../../../../../components/ZUILib/TextInput';
import CalenderSample from '../../../../../components/ZUILib/CalenderSample';
import CheckBox from '../../../../../components/ZUILib/CheckBox/CheckBox';

import commonUtil from '../../../../../utils/commonUtil';
import { eventCategory, eventType, ownerLabel, constChannel } from '../../../../../utils/clientConstant';
import { createTagsForInvalidFormControls } from '../../../../../utils/googleTagManagerUtils';

const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

const channel = commonUtil.getChannel();

export default class EventOwnerData extends Component {
  constructor(props) {
    super(props);
    console.log(this.props.userData, "userData in EventOwnerData");
    this.state = {
      isSectionVisible : '',
      phone3: this.props.userData?.phone3 ||this.props.userData?.cellular || '',
      phone: this.props.userData?.phone ||this.props.userData?.cellular || '',
      email: this.props.userData?.email || '',
      surName: this.props.userData?.surName || '',
      firstName: this.props.userData?.firstName || '',
      lastName: this.props.userData?.lastName || '',
      maternalName: this.props.userData?.maternalName || this.props.user.maternalName || '',
      inputId: ( this.props.userData?.maternalName || this.props.user.maternalName ) ? 'Segundoapellido' : 'Segundoapellido1' 
    }
    this.handlePopUp = this.handlePopUp.bind(this);
    this.formData = {
      userData: {
        title: '',
        ownerLabel: '',
        profileId: '',
        firstName: '',
        lastName: '',
        motherName: '',
        nickName: '',
        phone: '',
        dateOfBirth: '',
        email: '',
        isMinor: '',
        coOwner: '',
        sex: '',
        socialMediaId: '',
        socialMediaName: '',
        phone3:'',
        surName:'',
        phoneXvAnos: '',
        title4Value: '',
        celebrity:'',
        maternalName: '',
      },
    };
  }

  componentDidMount() {
    const is4Events = this.props.eventName === eventType.Other_Religious_Ceremonies ||
        this.props.eventName === eventType.Others || 
        this.props.eventName === eventType.Cumpleanos ||
        this.props.eventName === eventType.Open_House 

      if(is4Events && this.props.userData) {
        this.setValueOption({value:this.props.userData.title4Value === "true" ? true : false});
      }
    if (this.props.userData && this.props.userData.dateOfBirth) {
      this._CalenderSample.setDate(this.props.userData.dateOfBirth);
    }
    if(this.props.eventName === eventType.XV_Anos) {
      if(this.props.userData && this.props.userData.phoneXvAnos) {
        this.showEmailData.setChecked(true);
        this.permitAccess();
      }
    }
    if( this.props.userData && this.props.userData.title4Value) {
      this.setState({isSectionVisible:this.props.userData.title4Value})
    }
  }

  getformData = () => this.formData.userData;

  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  };

  handleAllowOnlyDigit = (e) => {
    const keyCode = e.charCode;
    if (keyCode > 37 && (keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  };

  permitAccess = (access) => {
    if (this.showEmailData.isChecked()) {
        this.forCheck.style.display = 'block';
      }else{
        this.forCheck.style.display = 'none';
      }
      this.props.onChange();
    };
   handleFieldChange = (e) => {
    const { name, value } = e.target;
      this.setState({ [name]: value });
      this.props.onChange();

      switch(name){
      
        case "firstName":
          if(this.txtFirstName && this.txtFirstName.clearError){
            this.txtFirstName.clearError();
          }
          break;
        case "lastName":
          if(this.txtLastName && this.txtLastName.clearError){
            this.txtLastName.clearError();
          }
          break;
        case "phone3":
          if(this.txtCellular3 && this.txtCellular3.clearError){
            this.txtCellular3.clearError();
          }
          break;
        case "phone":
          if(this.txtCellular && this.txtCellular.clearError){
            this.txtCellular.clearError();
          }
          break;
        case "email":
          if(this.txtEmail && this.txtEmail.clearError){
            this.txtEmail.clearError();
          }
          break;
        default:
          break;
        
      }
    };
  handleformValidate = () => {
    let title = '';
    let firstName = '';
    let lastName = '';
    let titleValid = true;
    let isFormValid = true;
    let cellularBottom = true;
    let title4EventsValid = true;


    const is4Events = this.props.eventName === eventType.Other_Religious_Ceremonies ||
        this.props.eventName === eventType.Others || 
        this.props.eventName === eventType.Cumpleanos ||
        this.props.eventName === eventType.Open_House 

    if(this.props.eventName === eventType.Bebe || is4Events || this.props.eventName === eventType.XV_Anos || this.props.eventName === eventType.Baptism || this.props.eventName === eventType.Mascotas) {
      const CellularValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.txtCellular3?.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateNumber, funcData: [this.txtCellular3?.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
   
      cellularBottom = commonUtil.validateTextInput(CellularValidationRules, this?.txtCellular3, null);
    }
   
    if (this.props.assignRole || this.props.optional) {
      if (this.props.eventName !== eventType.Boda && this.props.eventName !== eventType.Bebe && this.props.eventName !== eventType.Mascotas && !is4Events) {
      if (this.props.eventName !== eventType.Fiesta_Infantil ) {
        const titleValidValidationConfig = {
          functionRef: commonUtil.validateSelectedValue,
          funcData: [this?.title?.getSelectedIndex()],
          errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
        };
        titleValid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.title, null);
      } else {
        const titleValidValidationConfig = [
          {
            functionRef: commonUtil.validateName,
            funcData: [this.title.getValue(), 1, true],
            errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
          },
        ];
        titleValid = commonUtil.validateTextInput(titleValidValidationConfig, this.title, null);
      }}
    }

    const firstNameValidationRules = [
      {
        functionRef: commonUtil.isValueAvailable,
        funcData: [this.txtFirstName.getValue()],
        errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required'),
      },
      {
        functionRef: commonUtil.validateNameForAlphaNumeric,
        funcData: [this.txtFirstName.getValue(), 1, true],
        errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
      },
    ];

    const firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.txtFirstName, null);

    const lastNameValidationRules = [
      {
        functionRef: commonUtil.isValueAvailable,
        funcData: [this.txtLastName.getValue()],
        errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required'),
      },
      {
        functionRef: commonUtil.validateNameForAlphaNumeric,
        funcData: [this.txtLastName.getValue(), 1, true],
        errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
      },
    ];

    const lastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.txtLastName, null);
  //   if(this.props.eventName !== eventType.Boda){
  //   if (this.props.assignRole || this.props.optional) {
  //     if (titleValid) {
  //       title = this.title.getValue();
  //     }
  //   }
  // }
    if (firstNameValid) {
      firstName = this.txtFirstName.getValue();
    }

    if (lastNameValid) {
      lastName = this.txtLastName.getValue();
    }


    // const nickName = '';=
    // let motherNameValid = true;
    let nickNameValid = true;
    let cellularValid = true;
    let birthDateValid = true;
    let EmailValid = true;
    if( this.props.eventName === eventType.Boda) {
     const CellularValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
      { functionRef: commonUtil.validateNumber, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      // {
      //   functionRef: commonUtil.validateNumber,
      //   funcData: [this.txtCellular.getValue(), 1, true],
      //   errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
      // },
    ];
 
    cellularValid = commonUtil.validateTextInput(CellularValidationRules, this.txtCellular, null);
  
const EmailValidationRules = [
      {
        functionRef: commonUtil.validateEmail,
        funcData: [this.txtEmail.getValue()],
        errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required'),
      },
      // {
      //   functionRef: commonUtil.validateNumber,
      //   funcData: [this.txtCellular.getValue(), 1, true],
      //   errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid'),
      // },
    ];
 
    EmailValid = commonUtil.validateTextInput(EmailValidationRules, this.txtEmail, null);
  }
    isFormValid =
      titleValid &&
      firstNameValid &&
      lastNameValid &&
      cellularValid &&
      EmailValid && 
      cellularBottom && 
      title4EventsValid
        // titleValid &&
      //  &&
      // nickNameValid 
      // &&
      // birthDateValid 
      // &&
      // motherNameValid;
    if (isFormValid) {
        const userData = {
            ownerLabel: this.props.eventDetail?.labels?.[this.props.index] || '',
            profileId: this.props.userData.profileId || '',
            isMinor: 'false',
            coOwner: 'false',
            celebrity: 'false'
        };

        if (title) userData.title = title;
        if (firstName) userData.firstName = firstName;
        if (lastName) userData.lastName = lastName;
        
        // Phone fields
        if (this.txtCellular?.getValue()) userData.phone = this.txtCellular.getValue();
        if (this.txtCellular3?.getValue()) userData.phone3 = this.txtCellular3.getValue();
        if (this.props.eventName !== eventType.Boda && this.txtCellular3?.getValue()) {
            userData.phone3 = this.txtCellular3.getValue();
        }

        // Email
        const email = this.props.userData.emailId || this.props.userData.email;
        if (email) userData.email = email;

        // Gender
        if (this.props.userData?.gender && 
            (this.props.userData.gender === 'Male' || this.props.userData.gender === 'Female')) {
            userData.sex = this.props.userData.gender;
        }

        // Optional fields
        if (this.segundo4events?.getValue()) userData.surName = this.segundo4events.getValue();
        if (this.txtSurNameBoda?.getValue()) userData.maternalName = this.txtSurNameBoda.getValue();

        if (this.txtMaternalName?.getValue()) userData.maternalName = this.txtMaternalName.getValue();

        this.formData = { userData };
        return true;
    }

    const controls = [
      this.title,
      this.txtFirstName,
      this.txtLastName,
      // this.txtMotherName,
      this.txtnickName,
      // this.txtCellular,
      this.txtEmail,
      this._CalenderSample,
    ];

    const tagCompositor = c => ({
      event: 'alerta',
      phase: 'Crear mesa de regalos',
      step: 'Datos del festejado',
      color: 'Rojo',
      mensaje: 'Datos incompletos del administrador',
      mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
      seccion: 'Mesa de Regalos',
      tipo: 'formulario',
    });

    createTagsForInvalidFormControls({ controls, tagCompositor });

    // if (!titleValid) {
    //   this.props.focusOnError('title');
    // } else if (!firstNameValid) {
    //   this.props.focusOnError('firstname');
    // } else if (!lastNameValid) {
    //   this.props.focusOnError('lastname');
    // }
    // //  else if (!motherNameValid) {
    // //   this.props.focusOnError('middlename');
    // // }
    //  else if (!nickNameValid) {
    //   this.props.focusOnError('nickName');
    // } else if (!birthDateValid) {
    //   this.props.focusOnError('calendar');
    // } else if (!cellularValid) {
    //   this.props.focusOnError('cellular');
    // }else if(!cellularBottom){
    //   this.props.focusOnError('sectionBCellular');
    // }
    return false;
  };

  handlePopUp = (id) => {
    if (channel === 'wap') {
      const data = document.querySelector('#' + id);
      if (data.style.display === 'block') {
        data.style.display = 'none';
      } else {
        data.style.display = 'block';
      }
    }
  };

  setValueOption = (opt) => {
    this.setState({isSectionVisible: opt.value})
    if(opt.value === "Yo soy el festejado"){
      this.segundo4events.setValue('');
    }
  }


    getInputClass = ref => {
    if (ref && (ref.props.disabled === 'disabled')) {
      return 'tags-disabled'; // gray border or similar
    } 
      return 'tags-active'; // blue border or whatever
};


handleFocus = () => {
  this.setState({ inputId: 'Segundoapellido' });
};

handleBlur = () => {
  const isFilled = !!this.state.maternalName.trim();
  if(!isFilled){
  this.setState({ inputId: 'Segundoapellido1' });
  }
};
   
  render() {
    const { eventDetail, userData, lables, user } = this.props;
   const isSectionBVisible = (this.props.eventName === eventType.Mascotas ||
      this.props.eventName === eventType.XV_Anos ||
      this.props.eventName === eventType.Others||
      this.props.eventName === eventType.Open_House ||
      this.props.eventName === eventType.Cumpleanos ||
      this.props.eventName === eventType.Baptism ||
      this.props.eventName === eventType.Other_Religious_Ceremonies ||
      this.props.eventName === eventType.Bebe) 
    const textInputAttr = {
      textClassName: 'form-control',
      textLabelClassName: 'label_one',
      textHtmlId: 'calendar',
      textPlaceholder: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.dob.label'),
    };
    
    let SelectionOptions = [];
    SelectionOptions = ["Estoy celebrando a alguien más","Yo soy el festejado"].map((data) => {
      const title = {};
      title.id = data;
      title.labelResourceId = data;
      title.value = data;
      return title;
    });
  
    if (this.props.eventName === eventType.Fiesta_Infantil && this.title) {
      const titleOrganizer =
        this.props &&
        this.props.eventDetail &&
        this.props.eventDetail.titles &&
        this.props.eventDetail.titles.filter(item => item.toLowerCase().includes(ownerLabel.Organizer));
      this.title.textControl.value = titleOrganizer || ownerLabel.Organizer;
      this.title.textControl.disabled = true;
    }

    return ( 
     
      <React.Fragment>
        <div className='Section_One_Container'>
            {  (this.props.eventName === eventType.Boda) && 
            <div className='sectionOneABoda' >
              <div className="text-right labelStyle1"><span>{commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.camposObligatoros.label')}</span></div>
          <div className="formBlock">
           <h2 className={channel === 'wap' ? 'articleName' : 'subtitleModuleBoda titleForm'}>
              {/* {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.preperanteParaSi.label')}    */}
              {this.props.getFormHeadingLabelByEventType(this.props.eventName, 'left')}
          </h2>
        </div>

        <div className="formBlock">
          <TextInput
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            parentClassName={this.getInputClass(this.txtFirstName)}
            htmlId="firstname"
            label="Nombre"
            maxlength="100"
            required="true"
            star="*"
            disabled={user && user.firstName ? 'disabled' : false}
            value={this.state.firstName}
            ref={txtFirstName => (this.txtFirstName = txtFirstName)}
            name = "firstName"
            onChange={this.handleFieldChange}
            createEvent={true}
          />
        </div>
        <div className="formBlock">
          <TextInput
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            parentClassName={this.getInputClass(this.txtLastName)}
            htmlId="lastname"
            label="Primer apellido"
            maxlength="100"
            required="true"
            disabled={user && user.lastName ? 'disabled' : false}
            value={this.state.lastName}
            star="*"
            ref={txtLastName => (this.txtLastName = txtLastName)}
            name = "lastName"
            onChange={this.handleFieldChange}
            createEvent={true}
          />
        </div>
         <div className="formBlock">
          <TextInput
             className="inputMaterial"
             labelClassName="placeHolderMaterial"
             parentClassName={this.getInputClass(this.txtSurNameBoda)}
             htmlId={ this.state.inputId}  
             label="Segundo apellido"
             maxlength="100"
             disabled={(user && user.lastName) ? 'disabled' : false}
             value={this.state.maternalName}
             ref={txtSurNameBoda => (this.txtSurNameBoda = txtSurNameBoda)}
             name = "maternalName"
             onChange={this.handleFieldChange}
             onFocus={this.handleFocus}
             onBlur={this.handleBlur}
            createEvent={true}
          />
        </div>
        <div className="formBlock">
          <TextInput
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            parentClassName={this.getInputClass(this.txtCellular)}
            htmlId="cellular"
            label="Celular"
            required="true"
            maxlength="10"
            star="*"
            name="phone"
            onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
            onPaste={(e) => { this.onPasteFunc(e); }}
            disabled={user && user.cellular ? 'disabled' : false}
            value={this.state.phone}
            onChange={this.handleFieldChange}
            ref={txtCellular => (this.txtCellular = txtCellular)}
            createEvent={true}
          />
        </div>
        <div className="formBlock">
          <TextInput
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            htmlId="email"
            label="Correo electrónico"
            required="true"
            maxlength="100"
            star="*"
            onChange={this.handleFieldChange}
            name="email"
            parentClassName={this.getInputClass(this.txtEmail)}
            disabled={user && user.emailId ? 'disabled' : false}
            value={userData && userData.emailId ? userData.emailId :this.state.email}
            ref={txtEmail => (this.txtEmail = txtEmail)}
            createEvent={true}
          />
        </div>

         </div>}

         {/* ======================================SECTION 1B=================== */}
          { isSectionBVisible && 
          <div className='sectionOneB'>
            {/* headings and sub headings block */}
            <div className='formBlock_headingsB'>
              <h2 className={channel === 'wap' ? 'articleName' : 'titleModuleSectionB titleForm'}>
               { (this.props.eventName === eventType.XV_Anos) ?'¿Quién organiza los XV años?':'Tus datos'}
               </h2>
              {(this.props.eventName === eventType.XV_Anos) && <p className="subtitleModuleSectionB XVAnosSectionBDescWAP">
                 {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.alMenos.label')}
                </p>}
            </div>
            {/* Nombre required */}
              <div className="formBlock">
              <TextInput
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            parentClassName={this.getInputClass(this.txtFirstName)}
            htmlId="firstname"
            label="Nombre"
            maxlength="100"
            required="true"
            star="*"
            disabled={user && user.firstName ? 'disabled' : false}
            value={userData && userData.firstName ? userData.firstName : ''}
            ref={txtFirstName => (this.txtFirstName = txtFirstName)}
            createEvent={true}
             />
        </div>
            {/* primer appelido required */}
          <div className="formBlock">
          <TextInput
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            parentClassName={this.getInputClass(this.txtLastName)}
            htmlId="lastname"
            label="Primer apellido"
            maxlength="100"
            required="true"
            disabled={user && user.lastName ? 'disabled' : false}
            value={userData && userData.lastName ? userData.lastName : ''}
            star="*"
            ref={txtLastName => (this.txtLastName = txtLastName)}
            createEvent={true}
          />
        </div>
            {/* segundo appelido */}
             <div className="formBlock">
              <TextInput
               className="inputMaterial"
               labelClassName="placeHolderMaterial"
               parentClassName={this.getInputClass(this.txtMaternalName)}
               htmlId={this.state.inputId} 
               label="Segundo apellido"
               maxlength="100"
               required="true"
               disabled={user && user.lastName ? 'disabled' : false}
               value={userData && userData.maternalName ? userData.maternalName : ''}
               ref={txtMaternalName => (this.txtMaternalName = txtMaternalName)}
               createEvent={true}
               name="maternalName"
               onChange={this.handleFieldChange}
          />
        </div>
            {/* celular required */}
             <div className="formBlock">
             <TextInput
               className="inputMaterial"
               labelClassName="placeHolderMaterial"
               parentClassName={this.getInputClass(this.txtCellular3)}
               htmlId="sectionBCellular"
               label="Celular"
               required="true"
               maxlength="10"
               star="*"
               disabled={user && user.cellular ? 'disabled' : false}
               value={this.state.phone3}
               name="phone3"
               onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
               onPaste={(e) => { this.onPasteFunc(e); }}
               onChange={this.handleFieldChange}
               ref={txtcellular3 => (this.txtCellular3 = txtcellular3)}
               createEvent={true}
          />
            </div>
            {/* correo elctronico required */}
          <div className="formBlock">
           <TextInput
              className="inputMaterial"
               labelClassName="placeHolderMaterial"
               htmlId="middlename"
               label="Correo electrónico"
               parentClassName={this.getInputClass(this.txtMotherName)}
               required="true"
              maxlength="100"
              star="*"
              disabled={user && (user.emailId || userData.email) ? 'disabled' : false}
              value={
               userData &&  userData.emailId ? userData.emailId : userData.email ? userData.email : ''
              }
              ref={emailBottom => (this.emailBottom = emailBottom)}
              createEvent={true}
          />
        </div> 
          </div> }
         </div>
      </React.Fragment>
    );
  }
}
